/* eslint-disable */
/** 
* This file contains language specific message functions for tree-shaking. 
* 
*! WARNING: Only import messages from this file if you want to manually
*! optimize your bundle. Else, import from the `messages.js` file. 
* 
* Your bundler will (in the future) automatically replace the index function 
* with a language specific message function in the build step. 
*/
/**
 * 
 * @returns {string}
 */
/* @__NO_SIDE_EFFECTS__ */
export const kaspa_chain_about = () => `Kaspa is the fastest, open-source, decentralized & fully scalable Layer-1 in the world. The world’s first blockDAG – a digital ledger enabling parallel blocks and instant transaction confirmation – built on a robust proof-of-work engine with rapid single-second block intervals.`
